import { apiFetch, withQuery } from '@/lib/api/client';
import type { NotificationPage } from '@/types/api';

export function fetchNotifications(limit = 30): Promise<NotificationPage> {
  return apiFetch<NotificationPage>(withQuery('/notifications', { limit }));
}

/** Moves the "I have looked at the bell up to here" marker. The only write here. */
export function markNotificationsSeen(): Promise<{ seenAt: string }> {
  return apiFetch('/notifications/seen', { method: 'POST' });
}
